<template>
  <div class="modal-dialog">
    <div class="modal-content" :class="modalData.type === 'callback' ? 'callback' : ''"
         v-if="modalData.type === 'callback'">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <form-call-back></form-call-back>
      </div>
    </div>
    <div class="modal-content" :class="modalData.type === 'video' ? 'video' : ''" v-if="modalData.type === 'video'">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <iframe src="https://www.youtube.com/embed/b_5gqrVuFPk"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
      </div>
    </div>
    <div class="modal-content" v-if="modalData.type === 'login'">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <auth-component></auth-component>
      </div>
    </div>
    <div class="modal-content-media modal-content" v-if="modalData.type === 'media'">

      <button type="button" class="close" data-dismiss="modal">&times;</button>

      <div class="modal-body">
        <iframe src="https://www.youtube.com/embed/b_5gqrVuFPk"
                title="YouTube video player" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
      </div>
    </div>
    <div class="modal-content modal-vacancy-form" v-if="modalData.type === 'vacancies'">

      <button type="button" class="close" data-dismiss="modal">&times;</button>

      <div class="row m-0">
        <div class="col-12 col-md-6 left">
          <div id="vacancy-form">
            <form-vacancy></form-vacancy>
          </div>
        </div>
        <div class="col-12 col-md-6 right">
          <div class="list-block">
            <h4 class="modal-title">Отдел кадров</h4>

            <ul>
              <li class="item-services-ask">
                <p class="text-services-ask">Консультация по трудоустройству</p>
              </li>
              <li class="item-services-ask">
                <p class="text-services-ask">Собеседование</p>
              </li>
            </ul>
          </div>

          <div class="block-person d-block d-flex align-items-center">
            <div class="block-img">
              <img src="/local-images/callback-meneger.jpg" :alt="Lang.get('js.name_manager')"/>
            </div>
            <div class="description-person">
              <p class="title-person">{{ Lang.get('js.personnel_department') }}</p>
              <p class="name-person">{{ Lang.get('js.callback_form.name_manager') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormCallBack from './forms/FormCallBack';
import AuthComponent from './auth/AuthComponent';
import FormVacancy from './forms/FormVacancy';

export default {
  name: "modal-master",
  components: {
    FormCallBack,
    AuthComponent,
    FormVacancy
  },
  props: {
    modalData: {
      required: true,
      type: Object
    },
  },
  data() {
    return {
      Lang,
    }
  },
}
</script>
